import { PlusIcon } from '@heroicons/react/24/outline';

export interface ExternalCreateTaskButtonProps {
  onClick: () => void;
}

/**
 * Phase 25 Plan 25-07 D-21 — primary launcher button at the top-right of
 * `/external/projects/:projectId/board`. Internal users do NOT see this
 * button (caller gates by `audience === 'external'`); the kanban column
 * inline form (Phase 24 AddTaskInlineForm) remains the canonical internal
 * entry. Asymmetry is intentional.
 */
export function ExternalCreateTaskButton({ onClick }: ExternalCreateTaskButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
    >
      <PlusIcon className="w-4 h-4" aria-hidden />
      New task
    </button>
  );
}
